import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import KeywordDefinitionDeleteCommand from "./keyworddefinitiondeletecommand";
import { CkeditorConstants } from "../../src/utils";

const {
  command: { DELETE_KEYWORDS_LINK },
  helperAttributes: { TRACK_CHANGES_EDITING },
} = CkeditorConstants;

export default class KeywordDefinitionDeleteUI extends Plugin {
  init() {
    const { commands, plugins } = this.editor;
    commands.add(
      DELETE_KEYWORDS_LINK,
      new KeywordDefinitionDeleteCommand(this.editor)
    );

    const trackChangesEditing = plugins.get(TRACK_CHANGES_EDITING);

    trackChangesEditing.descriptionFactory.registerDescriptionCallback(
      (suggestion) => {
        const { attributes } = suggestion;
        if (!attributes || attributes.commandName !== DELETE_KEYWORDS_LINK) {
          return;
        }

        const content = `*Remove keywords:* ${attributes.commandParams.keywordText}`;
        return {
          type: "deletion",
          content,
        };
      }
    );
  }
}
